module.exports = "<app-application-menu></app-application-menu>\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/allocation/allocation.component.html
// module id = ./src/app/allocation/allocation.component.html
// module chunks = main